export default "__VITE_ASSET__CqytPCbg__"